import { types, flow, cast } from "mobx-state-tree"
import { returnBusiness } from "businesses/return-business"
import format from "date-fns/format"

const ReturnStore = types
  .model({
    data: types.optional(types.frozen(), []),
    deliveryInfo: types.maybeNull(types.frozen()),
    isLoading: types.maybeNull(types.boolean),
    customFilters: types.maybeNull(types.frozen()),
    selectedId: types.maybeNull(types.string, ""),
    searchText: types.maybeNull(types.string, ""),
    selectedErpOrder: types.maybeNull(types.string, ""),
  })
  .views(self => ({
    get filters() {
      const res = {}
      if (self.customFilters) {
        const dateItems = ["before_date", "after_date"]
        for (const prop in self.customFilters) {
          const val = self.customFilters[prop]
          if (val) {
            if (dateItems.includes(prop)) {
              res[prop] = format(val, "yyyy-MM-dd")
            } else {
              res[prop == "itemReceiveType" ? "receipt_type" : prop] = val
            }
          }
        }
      }

      return res
    },
  }))
  .actions(self => ({
    setData(data) {
      self.data = data
    },
    setSelectedId(id) {
      self.selectedId = id
    },
    setSearchText(val) {
      self.searchText = val
    },
    setCustomFilters(data) {
      self.customFilters = cast(data)
    },
  }))
  .actions(self => ({
    loadData: flow(function* (showLoading = true) {
      if (!self.searchText) {
        self.setData([])
        return
      }

      if (showLoading) self.isLoading = true
      const searchParams = {
        ...(self.filters || {}),
      }
      const data = yield returnBusiness.getData(searchParams)
      self.setData(data)
      if (showLoading) self.isLoading = false
    }),
  }))
export default ReturnStore
